// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"62a2428d","811":"d506bc70","859":"3ce6925f"}[chunkId] + ".chunk.js";
};